export interface LabelledRow<T> {
  id: string;
  original: T;
}

interface DataTableRowLabelsProps<T> {
  rows: LabelledRow<T>[];
  selectLabelId: (rowIndex: number) => string;
  selectLabel?: (row: T, rowId: string) => string;
}

/**
 * Accessible names for the row checkboxes, referenced through `aria-labelledby`.
 * Row labels name creators and coupon codes, and session recorders upload
 * `aria-label` values as-is while masking text (issue #727).
 *
 * `hidden`, not `sr-only`: a node referenced by aria-labelledby still names its
 * element, and hidden it is not read a second time after the table.
 */
export function DataTableRowLabels<T>({
  rows,
  selectLabelId,
  selectLabel,
}: DataTableRowLabelsProps<T>) {
  if (!selectLabel) return null;
  return (
    <div hidden>
      {rows.map((row, rowIndex) => (
        <span key={row.id} id={selectLabelId(rowIndex)}>
          {selectLabel(row.original, row.id)}
        </span>
      ))}
    </div>
  );
}
